import { AnyRoute } from '../../common/types/routes.js'
import allianceLogo from '../assets/logos/alliance_white.svg'
import { TopNavigationProps } from '../components/top-navigation/top-navigation.js'
import { themeLabels } from '../hero-data.js'
import { getMenuItems } from '../menu.js'
import { View } from '../types.js'
import { setLanguage } from '../utils/language.js'
import { setTheme } from '../utils/theme.js'

export const getNavigationProps = (view: View): TopNavigationProps => {
    const { state } = view
    const { route, lang } = state

    return {
        lang,
        logo: { src: allianceLogo, alt: 'Alliance' },
        items: getMenuItems(state.hasActiveCampaign && !state.activeCampaignAnswered).map(
            (item) => ({
                text: item.text(lang),
                url: item.url,
                href: item.href,
                isActive: item.matchingRoutes.includes(route.definition as AnyRoute<View>),
                isButton: item.isButton,
                onClick: item.onClick ? () => item.onClick!(view) : undefined,
            }),
        ),
        languageButtons: [
            {
                text: 'ET',
                isActive: lang === 'et',
                onClick: () => setLanguage(view, 'et'),
            },
            {
                text: 'EN',
                isActive: lang === 'en',
                onClick: () => setLanguage(view, 'en'),
            },
        ],
        user: state.user
            ? {
                  name: state.user.name,
                  role: state.user.role,
                  applicationRoles: state.user.applicationRoles,
                  isManager: state.user.isManager,
                  onLogout: () => {
                      void fetch('/api/logout', { method: 'POST' }).then(() => {
                          state.isAuthenticated = false
                          state.user = undefined
                          state._onAuthChange?.()
                      })
                  },
              }
            : undefined,
        theme: {
            value: state.themePreference,
            onChange: (pref, origin) => setTheme(view, pref, origin),
            labels: themeLabels(lang),
        },
    }
}
